import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TariffCode } from 'src/app/core/models/tariff-code';
import { PaginatedResults } from 'src/app/core/models/paginated_results_model';
import { PaginationOptions } from 'src/app/core/models/pagination_options';
import { TariffCodeService } from 'src/app/core/services/general/tariff-code.service';

@Component({
  selector: 'app-search-tariff-code',
  templateUrl: './search-tariff-code.component.html',
  styleUrls: ['./search-tariff-code.component.scss']
})
export class SearchTariffCodeComponent {
  public loading = true;
  public initialLoading = true;
  public tariffCodesList!: Array<TariffCode>;
  public paginatedResults!: PaginatedResults;
  public paginationOptions = new PaginationOptions(
    { sort: 'code', direction: 'asc' },
    'tariff_codes'
  );

  public sortColumns = [
    'code',
    'service_type_code',
    'description',
    'rate',
    'currency',
    'status',
  ];

  constructor(
    private router: Router,
    private tariffCodeService: TariffCodeService,
    public activeModal: NgbActiveModal
  ) { }

  ngAfterViewInit(): void {
    this.search();
  }

  search() {
    this.loading = true;
    this.tariffCodeService
      .search(this.paginationOptions)
      .subscribe((res: PaginatedResults) => {
        this.paginatedResults = res;
        this.tariffCodesList = res.data.map((u) => new TariffCode(u));
        this.initialLoading = false;
        this.loading = false;
      });
  }

  select(tariffCode: TariffCode) {
    this.activeModal.close(tariffCode);
  }

  toggleFilter() {
    this.paginationOptions.toggleFilter();
    this.paginatedResults.current_page = 1;
    this.onPageNumberChanged();
  }

  onPageNumberChanged() {
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.paginationOptions.saveUpdatedOptions();
    this.onPaginationChanged();
  }

  onPerPageChanged() {
    this.paginatedResults.current_page = 1;
    this.paginationOptions.perPage = this.paginatedResults.per_page;
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.onPageNumberChanged();
  }

  changeSort(field: any) {
    if (this.paginationOptions.sort === field) {
      this.paginationOptions.toggleDirection();
    } else {
      this.paginationOptions.sort = field;
      this.paginationOptions.resetDirection();
    }

    this.paginatedResults.current_page = 1;
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.onPageNumberChanged();
  }

  onPaginationChanged() {
    this.search();
  }
}
